import { render, staticRenderFns } from "./Atualizacao.vue?vue&type=template&id=22a72d97"
import script from "./Atualizacao.vue?vue&type=script&lang=js"
export * from "./Atualizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports